export const pages = {
  auth: {
    login: {
      title: 'Iniciar sesión'
    },
    confirmation: {
      title: 'Confirmación',
      description:
        'Te hemos enviado un correo con un código a __var_0__. Puede tardar hasta un minuto.'
    },
    verifyEmail: {
      title: 'Verificación de correo'
    },
    reset: {
      title: 'Restablecer contraseña'
    },
    otp: {
      title: 'Código de verificación',
      description:
        'Te hemos enviado un correo con un código a __var_0__. Puede tardar hasta un minuto.'
    },
    register: {
      title: 'Registro __var_0__'
    },
    invite: {
      title: 'Bienvenido a Live Bright Connect',
      description: 'Elige tu tipo de perfil'
    }
  },
  notification: {
    title: 'Notificaciones',
    notFound: 'Todavía no tienes notificaciones.',
    description:
      'Puedes ver nuevas solicitudes de artistas en la sección "Artistas" de tu perfil.'
  },
  loyalty: {
    inputLabel: 'Tu enlace:',
    registered: 'Registrado',
    followed_link: 'Clics en el enlace',
    inputDescription:
      'Para invitar a una artista, envía tu enlace de registro.',
    artist: {
      title: 'Invitación a la plataforma',
      description:
        'La artista que complete el registro con tu enlace se considerará invitada por ti.'
    },
    club: {
      title: 'Programa de fidelización',
      note: 'La artista que complete el registro con tu enlace se considerará invitada por ti.',
      description: '¡Consigue artistas sin comisión!',
      text: '👯‍♀️ ¿Tuviste un casting y la artista no encajó? ¿Alguien está terminando un contrato? Envíale tu enlace personal.',
      content:
        'Cuando la artista se registra con tu enlace, se contabiliza. 📌 Por cada 5 artistas obtienes 1 contrato sin comisión por 1 mes calendario. Incluso si la artista elige otro club, igualmente se contará en tu marcador.‼️ Para participar, tu club debe completar el perfil y ser visible en la búsqueda. Comparte la plataforma y obtén beneficios desde ahora.'
    }
  },
  language: {
    title: 'Idiomas',
    description: 'Elige el idioma de la plataforma',
    options: {
      ru: 'Ruso',
      en: 'Inglés',
      uk: 'Ucraniano',
      it: 'Italiano',
      de: 'Alemán',
      tr: 'Turco',
      es: 'Español'
    }
  },
  profilePage: {
    techSupport: 'Soporte técnico',
    privacy: 'Condiciones y privacidad',
    artist: {
      work: 'Trabajar en el club',
      infoEditSection: 'Edición',
      infoAppSection: 'Solicitud',
      personalInfo: 'Información personal',
      portfolio: 'Portafolio',
      invitationAndRequests: 'Solicitudes e invitaciones',
      hideProfile: 'Ocultar perfil',
      loyaltyLink: 'Invita a un amigo'
    },
    club: {
      clubInfoSection: 'Información del club',
      artistsSection: 'Artistas',
      artistHiring: 'Contratación de artistas',
      loyaltyProgram: 'Programa de fidelización',
      editingSection: 'Edición',
      clubInfo: 'Información personal',
      conditions: 'Condiciones',
      approvedArtists: 'Artistas aprobados',
      requestsAndInvitations: 'Solicitudes e invitaciones',
      applicationSection: 'Solicitud'
    }
  },
  portfolioPage: {
    title: 'Portafolio',
    warnNotPublished:
      'El portafolio no está publicado. Completa tu portafolio para publicarlo.',
    warnfillPortfolio: 'Completar portafolio',
    warnf: 'Completar portafolio',
    warnFillSection:
      'Completa esta sección para aumentar las posibilidades de recibir invitaciones.'
  },
  profileInfo: {
    club: {
      title: 'Sobre'
    },
    artist: {
      title: 'Sobre'
    }
  },
  clubTerms: {
    title: 'Condiciones',
    description:
      'Intenta completar todos los pasos. El atractivo del anuncio para las artistas depende de ello. Si surgen dificultades, contacta con soporte.',
    progressSteps: {
      schedule: 'Horario de trabajo del club',
      contractTerms:
        'Contrato mínimo, horario de artistas, boletos, traslado desde el aeropuerto',
      payments:
        'Pagos: tarifa, garantía, multas, topless, go-go, depósito, espectáculo, té, consumo, menú loco',
      workConditions:
        'Tipo de consumo, coreógrafo, sesiones de fotos, barras (pilones), cantidad',
      housing: 'Información sobre vivienda. Foto.',
      penalties: 'Tabla de multas',
      photo: 'Foto del club',
      video: 'Video del club'
    }
  },
  clubEmployers: {
    title: 'Artistas aprobados',
    tabs: {
      pending: 'Pendientes',
      onContract: 'En contrato'
    }
  },
  requestAndInvitation: {
    title: 'Solicitudes e invitaciones'
  },
  onboarding: {
    club: {
      schedule: {
        title: 'Horario del club',
        popups: {
          title: 'Horario de apertura'
        },
        changeAllWorkTimes: 'Cambiar todas las horas de trabajo'
      },
      contractTerms: {
        title: 'Condiciones de trabajo en el club',
        form: {
          minimalContractTerm: {
            label: 'Plazo mínimo del contrato',
            unit: 'Semanas'
          },
          artistsSchedule: {
            label: 'Horario de los artistas'
          }
        }
      },
      payments: {
        title: 'Pagos',
        rateFieldDescription:
          'Si tienes una tarifa con importe fijo, completa solo uno de los campos.'
      },
      workConditions: {
        title: 'Condiciones de trabajo en el club',
        form: {
          noExperienceEmployment: 'Empleo de artistas sin experiencia',
          additionalInfo: {
            label: 'Información adicional sobre el club',
            placeholder:
              'Puedes escribir sobre promociones o bonificaciones en tu club u otra información de interés para las artistas.',
            description: 'Introduce al menos 100 caracteres'
          }
        },
        popups: {
          dressCode: {
            enterDressCodeElement:
              'Introduce un elemento del código de vestimenta',
            description:
              'Selecciona el código de vestimenta para artistas de tu club. Agrega las posiciones faltantes.'
          }
        }
      },
      housing: {
        title: 'Información sobre vivienda'
      },
      penalties: {
        title: 'Multas',
        description:
          'Agrega tu posición si no la encuentras en la lista proporcionada'
      },
      photo: {
        title: 'Foto del club',
        description: 'Sube fotos del club. Puedes hacer cambios más tarde',
        options: {
          hallNoGuests: 'Foto del salón vacío',
          hallWithGuests: 'Foto del salón con invitados',
          privateRooms: 'Foto de habitaciones privadas',
          scene: 'Foto de la escena'
        }
      },
      video: {
        title: 'Video del club',
        description: 'Sube videos del club. Puedes hacer cambios más tarde',
        options: {
          ClubTour: 'Recorrido del club (salón vacío)',
          EventVideo: 'Eventos (salón con invitados)',
          WorkingHours: 'Escenario en funcionamiento'
        }
      }
    },
    artist: {
      work: {
        title: 'Experiencia en clubes',
        addWorkPlace: 'Agregar lugar de trabajo',
        notHaveWorkExperience: 'Continuar sin experiencia'
      },
      language: {
        title: 'Idiomas',
        languageProfinience: 'Competencia en idiomas extranjeros'
      },
      parametres: {
        title: 'Parámetros'
      },
      about: {
        title: 'Sobre ti',
        description: 'Escribe sobre ti lo que será interesante para el club',
        textAreaDescription: 'Introduce al menos 100 caracteres',
        textAreaPlaceholder: 'Escribe aquí...'
      },
      video: {
        title: 'Video',
        videoForHostesVacancy:
          '2. Sube un video de presentación para la vacante de Hostess',
        videoForGogoVacancy:
          '1. Sube un video de baile para la vacante de Go-go'
      },
      photo: {
        title: 'Foto',
        description: 'Sube fotos. Deben ser sin filtros ni Photoshop.',
        FaceNoMakeup: 'Rostro sin maquillaje',
        FaceWithMakeup: 'Rostro con maquillaje',
        FreePose: 'Foto en pose libre',
        FullBodyOnHeels: 'Foto de cuerpo completo en tacones',
        LingerieOrSwimsuit: 'Foto en lencería o traje de baño',
        selectMainPhoto: 'Elige la foto principal'
      }
    }
  },
  workInteraction: {
    club: {
      artistHaveContract: 'La artista ya está trabajando en el club',
      incompleted:
        'Para enviar invitaciones, debes completar tu perfil al 100%.'
    },
    artist: {
      weCanRequestLastWorkDate:
        'Solicita la fecha de finalización del contrato al club.',
      clubSetLastWorkDate:
        'El club estableció tu última fecha de trabajo en este club.',
      clubNotHiring:
        'No puedes enviar una solicitud, ya que el club no tiene abierta la contratación de artistas.',
      pendingRequest: 'No puedes enviar más de una solicitud en 48 horas.',
      haveContract:
        'No puedes enviar una solicitud, ya que tienes un contrato activo.',
      hidden:
        'No puedes enviar una solicitud, ya que tu perfil está oculto en la búsqueda.',
      incompleted:
        'No puedes enviar una solicitud, ya que no has completado tu perfil.'
    }
  },
  notFoundWorkItem: {
    title: 'Esta invitación o solicitud ya no existe.',
    description: 'Lo sentimos, esta página no existe. Por favor, vuelve atrás.'
  },
  notFoundCurrentWork: {
    title: 'Sin contrato activo',
    description:
      'En este momento no tienes un contrato activo. Ve a la búsqueda y envía una solicitud al club para comenzar un contrato.'
  },
  clubFullProfile: {
    clubVideo: 'Video del club',
    clubPhoto: 'Foto del club',
    clubHousingPhoto: 'Foto de vivienda',
    minimalContractDuration: 'Contrato mínimo',
    artistWorkSchedule: 'Horario de trabajo',
    paymentFrequescyMessage: 'Pagos por consumo al artista — 1 vez cada'
  },
  privacyPolicy: {
    title: 'Acuerdo de usuario y Política de privacidad'
  },
  chat: {
    requestSupport: {
      inviteManagerInChat: 'Invitar a un gerente al chat',
      managerIsInChat: 'El gerente está en el chat',
      manageRequestPending: 'El gerente se agregará pronto'
    },
    admin: {
      assistanceProvided: 'Ayuda proporcionada',
      openDirectChat: 'Открыть личный чат',
      openWhatsApp: 'Abrir WhatsApp',
      phoneNumberNotAvailable: 'Número de teléfono no disponible'
    }
  }
};
